import { render, staticRenderFns } from "./BarTabConsumptionInfoSidebar.vue?vue&type=template&id=4c3babac&scoped=true&"
import script from "./BarTabConsumptionInfoSidebar.vue?vue&type=script&lang=js&"
export * from "./BarTabConsumptionInfoSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BarTabConsumptionInfoSidebar.vue?vue&type=style&index=0&id=4c3babac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3babac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3babac')) {
      api.createRecord('4c3babac', component.options)
    } else {
      api.reload('4c3babac', component.options)
    }
    module.hot.accept("./BarTabConsumptionInfoSidebar.vue?vue&type=template&id=4c3babac&scoped=true&", function () {
      api.rerender('4c3babac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-bar/BarTabConsumptionInfoSidebar.vue"
export default component.exports